import React, { useState } from "react";
import "./Reviews.css";

export default function Reviews() {
  const [reviews, setReviews] = useState([]);
  const [name, setName] = useState("");
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const SCRIPT_URL =
    "https://script.google.com/macros/s/AKfycbwy1GT9TS5gzCIwMpn_zTob2VmffmxcPTl8AaSem4x0fXfPnMsXjtZTgf9eU9gSLjJY/exec";

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !comment || rating === 0) {
      alert("Please fill all fields and select a rating!");
      return;
    }

    setLoading(true);

    const saveReview = async (imageData = "") => {
      const reviewData = {
        type: "review",
        name,
        rating,
        comment,
        image: imageData,
      };

      try {
        await fetch(SCRIPT_URL, {
          method: "POST",
          body: JSON.stringify(reviewData),
        });

        const newReview = {
          ...reviewData,
          date: new Date().toLocaleDateString(),
        };

        setReviews([newReview, ...reviews]);

        setName("");
        setRating(0);
        setComment("");
        setImage(null);

        alert("Review submitted successfully!");
      } catch (error) {
        console.error("Error submitting review:", error);
        alert("Something went wrong!");
      } finally {
        setLoading(false);
      }
    };

    // If image selected → convert to base64
    if (image) {
      const reader = new FileReader();
      reader.onload = () => {
        saveReview(reader.result);
      };
      reader.readAsDataURL(image);
    } else {
      saveReview();
    }
  };

  return (
    <section className="reviews-section section-space pt-lg-5 pb-lg-4">
      <div>
        <h1 className="reviews-title text-center mb-4">
          Share Your Experience
        </h1>

        {/* Review Form */}
        <div className="review-form-card card shadow mb-5 p-4">
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Your Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="form-input"
            />

            {/* Star Rating */}
            <div className="star-rating mb-3">
              {[1, 2, 3, 4, 5].map((star) => (
                <span
                  key={star}
                  className={star <= rating ? "star filled" : "star"}
                  onClick={() => setRating(star)}
                >
                  ★
                </span>
              ))}
            </div>

            <textarea
              placeholder="Your Review"
              rows="5"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              required
              className="form-input"
            ></textarea>

            <label className="custom-file-upload">
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setImage(e.target.files[0])}
              />
              Upload Image
            </label>

            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit Review"}
            </button>
          </form>
        </div>

        {/* Display Reviews */}
        <div className="reviews-list">
          {reviews.length === 0 ? (
            <p className="text-center">
              {/* No reviews yet. Be the first to share your experience! */}
            </p>
          ) : (
            reviews.map((rev, index) => (
              <div className="review-card card shadow mb-3 p-3" key={index}>
                <div className="review-header d-flex justify-content-between align-items-center mb-2">
                  <h5 className="mb-0">{rev.name}</h5>
                  <span className="review-rating">{rev.rating} ★</span>
                </div>
                <p>{rev.comment}</p>
                {rev.image && (
                  <img
                    src={rev.image}
                    alt="User Upload"
                    className="review-image mt-2"
                  />
                )}
                <small className="review-date d-block mt-2">
                  {rev.date}
                </small>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
}